"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ZoomPanel = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var _clsx6 = _interopRequireDefault(require("clsx"));
var _GpsFixed = _interopRequireDefault(require("@material-ui/icons/GpsFixed"));
var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));
var _Remove = _interopRequireDefault(require("@material-ui/icons/Remove"));
var _reactLoading = _interopRequireDefault(require("react-loading"));
var _pittaModules = require("@thingsw/pitta-modules");
var _Fab = require("./Fab");
var _Tooltip = require("./Tooltip");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    zoomControlDiv: _objectSpread(_objectSpread({
      position: 'absolute',
      bottom: 36
    }, theme.direction === 'rtl' ? {
      left: 20
    } : {
      right: 20
    }), {}, {
      display: 'flex',
      overflow: 'visible',
      flexDirection: 'column',
      zIndex: 80
    }),
    renewalZoomControlDiv: _objectSpread({
      bottom: 88
    }, theme.direction === 'rtl' ? {
      left: 16
    } : {
      right: 16
    }),
    noAbsZoomControlDiv: {
      position: 'unset'
    },
    zoomControlEventMapDiv: {},
    zoomControlBtn: {
      borderRadius: '50%',
      width: 40,
      height: 40,
      color: function color(props) {
        return props.colors.primary['1'];
      },
      backgroundColor: function backgroundColor(props) {
        return props.colors.primary['0'];
      },
      minHeight: 30
    },
    eventMapControlBtn: {},
    gpsFixBtn: {
      marginBottom: theme.spacing(0.5)
    },
    zoomInBtn: {
      // borderRadius: theme.spacing(1, 1, 0, 0),
    },
    zoomOutBtn: {
      // borderRadius: theme.spacing(0, 0, 1, 1),
    },
    noHover: {
      '&:hover': {
        fill: function fill(props) {
          return props.colors.primary['3'];
        },
        color: function color(props) {
          return props.colors.primary['3'];
        },
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        }
      },
      '&:active': {
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        opacity: 0.35,
        fill: function fill(props) {
          return props.isFleeta ? props.colors.primary['1'] : props.colors.primary['7'];
        },
        color: function color(props) {
          return props.isFleeta ? props.colors.primary['1'] : props.colors.primary['7'];
        }
      }
    },
    noFocus: {
      '&:focus': {
        backgroundColor: function backgroundColor(props) {
          return props.colors.primary['0'];
        },
        fill: function fill(props) {
          return props.colors.primary['3'];
        },
        color: function color(props) {
          return props.colors.primary['3'];
        }
      }
    }
  };
});
var ZoomPanel = function ZoomPanel(props) {
  var _clsx, _t, _t2, _t3;
  var onMyLocation = props.onMyLocation,
    onFailedLocation = props.onFailedLocation,
    onZoomIn = props.onZoomIn,
    onZoomOut = props.onZoomOut,
    locPerm = props.locPerm,
    eventMap = props.eventMap,
    hideLocation = props.hideLocation,
    t = props.t,
    onLoading = props.onLoading,
    loading = props.loading,
    renewal = props.renewal,
    renewal2 = props.renewal2,
    colors = props.colors,
    noabs = props.noabs;
  var classes = useStyles(props);
  var theme = (0, _styles.useTheme)();
  var mobile = (0, _core.useMediaQuery)(theme.breakpoints.down(_pittaModules.Webviewer.mobile));
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx6.default)(classes.zoomControlDiv, (_clsx = {}, _defineProperty(_clsx, classes.renewalZoomControlDiv, renewal), _defineProperty(_clsx, classes.zoomControlEventMapDiv, eventMap), _defineProperty(_clsx, classes.noAbsZoomControlDiv, noabs), _clsx))
  }, (renewal || !hideLocation) && /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    disableTouchListener: mobile,
    title: (_t = t('My location')) !== null && _t !== void 0 ? _t : 'My location',
    PopperProps: {
      disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    },
    placement: theme.direction === 'rtl' ? 'right' : 'left',
    className: (0, _clsx6.default)(classes.noFocus, _defineProperty({}, classes.noHover, mobile))
  }, /*#__PURE__*/_react.default.createElement(_Fab.Fab, {
    size: "small",
    variant: "rounded",
    className: (0, _clsx6.default)(classes.zoomControlBtn, classes.gpsFixBtn, _defineProperty({}, classes.eventMapControlBtn, eventMap)),
    onClick: function onClick() {
      if (locPerm === 0) {
        return onFailedLocation === null || onFailedLocation === void 0 ? void 0 : onFailedLocation();
      }
      if (navigator.geolocation) {
        onLoading(true);
        var timer = setTimeout(function () {
          console.log('getCurrentPosition', 'timeout loading false');
          onLoading(false);
        }, 15000);
        navigator.geolocation.getCurrentPosition(function (position) {
          console.log('getCurrentPosition', position);
          clearTimeout(timer);
          onLoading(false);
          onMyLocation(position);
        }, function (e) {
          console.log('getCurrentPosition is failed', e);
          onLoading(false);
          if (e.code === e.PERMISSION_DENIED) {
            onFailedLocation === null || onFailedLocation === void 0 ? void 0 : onFailedLocation();
          }
        }, {
          timeout: 10000,
          enableHighAccuracy: true,
          maximumAge: 0
        });
      }
    }
  }, loading ? /*#__PURE__*/_react.default.createElement(_reactLoading.default, {
    type: "spokes",
    color: _pittaModules.LightColors.primary['4'],
    height: 18,
    width: 18
  }) : /*#__PURE__*/_react.default.createElement(_GpsFixed.default, {
    fontSize: "small",
    htmlColor: renewal2 ? colors.primary['1'] : undefined
  }))), !mobile && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    title: (_t2 = t('Zoom in')) !== null && _t2 !== void 0 ? _t2 : 'Zoom in',
    PopperProps: {
      disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    },
    placement: theme.direction === 'rtl' ? 'right' : 'left'
  }, /*#__PURE__*/_react.default.createElement(_Fab.Fab, {
    size: "small",
    variant: "rounded",
    className: (0, _clsx6.default)(classes.zoomControlBtn, classes.zoomInBtn, _defineProperty({}, classes.eventMapControlBtn, eventMap)),
    onClick: onZoomIn
  }, /*#__PURE__*/_react.default.createElement(_Add.default, {
    fontSize: "small"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      height: 12
    }
  }), /*#__PURE__*/_react.default.createElement(_Tooltip.Tooltip, {
    title: (_t3 = t('Zoom out')) !== null && _t3 !== void 0 ? _t3 : 'Zoom out',
    PopperProps: {
      disablePortal: true,
      modifiers: {
        preventOverflow: {
          enabled: false
        },
        flip: {
          enabled: false
        }
      }
    },
    placement: theme.direction === 'rtl' ? 'right' : 'left'
  }, /*#__PURE__*/_react.default.createElement(_Fab.Fab, {
    size: "small",
    variant: "rounded",
    className: (0, _clsx6.default)(classes.zoomControlBtn, classes.zoomOutBtn, _defineProperty({}, classes.eventMapControlBtn, eventMap)),
    onClick: onZoomOut
  }, /*#__PURE__*/_react.default.createElement(_Remove.default, {
    fontSize: "small"
  })))));
};
exports.ZoomPanel = ZoomPanel;